import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Col, Row } from 'react-bootstrap'
import { PackageDimensions } from '/src/components/commerce/product/productUtil'
import { Button, Textarea, TextInput } from '/src/components/common'
import { postRequest } from '/src/httpClient'

import './enquiry_form.scss'

export const EnquiryForm = ({ product, type, setDisplay }) => {
  const [message, setMessage] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, setValue, handleSubmit, formState: { errors } } = useForm()

  const onSubmit = (data) => {
    const body = {
      ...data,
      product: product ? product.drupal_id : null
    }

    setIsLoading(true)
    postRequest('/api/enquiry/create', body).then(response => {
      if (response) {
        setMessage('Your enquiry has been submitted successfully')
      }

      setTimeout(() => {
        setIsLoading(false)
        setDisplay(false)
      }, 4500)
    })
  }

  return (
    <div className="enquiry-form-container">
      <form id="enquiry-form" name="enquiry-form" key="enquiry-form" onSubmit={handleSubmit(onSubmit)}>
        {message ? (
          <Row className="form-message">
            <Col sm={12}>
              <p>{message}</p>
            </Col>
          </Row>
        ) : (
          <>
            <Row>
              {product !== undefined && (
                <Col sm={12}>
                  <Row>
                    <Col sm={12}>
                      <div className='title-container mb-3'>
                        <h4 className="title">{product.title}</h4>
                      </div>
                      <div className="product-details-view mb-5">
                        <ul>
                          <li>
                            <label>Product number:</label>
                            <span>{product.id}</span>
                          </li>
                          {product.weight && product.weight.number && (
                            <li>
                              <label>Weight:</label>
                              <span>{Number(product.weight.number).toPrecision(6)} {product.weight.unit}</span>
                            </li>
                          )}
                          {product.dimensions && (
                            <li>
                              <label>Package dimensions:</label>
                              <span><PackageDimensions dimensions={product.dimensions} /></span>
                            </li>
                          )}
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Col>
              )}
              <Col sm={6}>
                <TextInput 
                  label="Name"
                  register={register('name', {
                    required: true,
                  })} />
              </Col>
              <Col sm={6}>
                <TextInput 
                  label="Email"
                  error={errors.email}
                  register={register('email', {
                    required: true,
                    pattern: {
                      value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                      message: 'Please provide a valid email address'
                    }
                  })} />
              </Col>
              <Col sm={6}>
                <TextInput 
                  label="Phone"
                  error={errors.phone}
                  register={register('phone', {
                    required: true,
                    pattern: {
                      value: /^[0-9]+$/,
                      message: 'Please provide a valid phone number'
                    }
                  })} />
              </Col>
              <Col sm={6}>
                <TextInput 
                  label="Postcode"
                  error={errors.postcode}
                  register={register('postcode', {
                    required: true,
                    pattern: {
                      value: /^[0-9]{4}$/,
                      message: 'Please provide a valid postcode'
                    }
                  })} />
              </Col>
              <Col sm={12}>
                <Textarea 
                  label="Enquiry"
                  register={register('enquiry', {
                    required: true,
                  })} />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Button disabled={isLoading} variant="primary" type="submit">
                  {isLoading ? 'Sending...' : 'Send Enquiry'}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </form>
    </div>
  )
}
